import RecentViews from './RecentViews';

export default RecentViews;